import { render, staticRenderFns } from "./Chamados.vue?vue&type=template&id=2679f283&lang=pug&"
import script from "./Chamados.vue?vue&type=script&lang=js&"
export * from "./Chamados.vue?vue&type=script&lang=js&"
import style0 from "./Chamados.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports